import { useState } from 'react'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector, useUnMount } from 'shared/hooks'

import { app } from '../../../actions/app'
import './style.scss'
import { filters } from '../../../actions/filters'
import iconSearch from '../../../assets/image/icons/svg/search-icon-grey.svg'
import {
	campaignsActions,
	campaignsSelectors
} from '../../../redux/reducers/campaigns'
import ButtonCreateCampaigns from '../../atoms/buttonCreateCampaigns'
import TextFieldCustom from '../../atoms/TextFieldCustom'
import { Statuses } from './Statuses'

export function CampaignFilters({
	archive = false,
	orderby = '',
	setPage
}: {
	archive?: boolean
	orderby?: string
	setPage(page: number): void
}) {
	const keywords = useAppSelector(campaignsSelectors.search)
	const [search, setSearch] = useState(keywords)
	const filter = useAppSelector(campaignsSelectors.filterQuery)

	const dispatch = useAppDispatch()

	const onSearchEnter = () => {
		if (search !== keywords) {
			dispatch(campaignsActions.setSearch(search))
		}
	}

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		setPage(0)

		app.changeTableContentLoaderStatus(true)

		const body: any = {
			archived: archive,
			keywords: search
		}

		if (!archive) {
			body.filter = filter
			body.orderby = orderby
		}

		filters.getCampaigns(body)
	}, [filter, orderby, archive, search])

	useUnMount(() => {
		dispatch(campaignsActions.setSearch(search))
	})

	return (
		<div className='table-container-controllers'>
			<p className='campaigns-title'>Campaigns</p>
			<div className='btn-group'>
				<div className='filter-search'>
					<TextFieldCustom
						endAdornment={
							<img
								alt='search'
								className='icon-search'
								onClick={onSearchEnter}
								src={iconSearch}
							/>
						}
						onBlur={onSearchEnter}
						onChange={e => setSearch(e.target.value)}
						onEnter={onSearchEnter}
						placeholder={'Search'}
						value={search}
					/>
				</div>
				{!archive && [
					<Statuses key='✅' />,
					<ButtonCreateCampaigns
						classes='action-btn campaign'
						key='➕'
						text={'Add campaign'}
						type='new'
					/>
				]}
			</div>
		</div>
	)
}
